import { SET_CONFIGURATION } from '../constants/actionTypes'
import config from 'partnerConfigurations'


export const setConfiguration = (partnerId) => ({
    type: SET_CONFIGURATION,
    config: config[partnerId]
})
